import { initModals } from "flowbite";
import React, { useEffect } from "react";
import { Button } from "@windmill/react-ui";
import { useState } from "react";

import { useWeb3Modal } from '@web3modal/wagmi/react'
import { useAccount, useSignMessage, useConnect, useDisconnect } from "wagmi";
import { InjectedConnector } from "wagmi/connectors/injected";

import { useWalletModal } from "@solana/wallet-adapter-react-ui";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import bs58 from 'bs58';

import * as Yup from 'yup';
import { Formik } from 'formik';

import { chains } from "../../utils/Chains"
import { useDispatch } from "../../store";
import toast, { Toaster } from "react-hot-toast";
import useApi from "../../hooks/useApi";
import useScriptRef from "../../hooks/useScriptRef";
import { ChangePage } from "../../store/reducers/menu";
import useMediaQuery from "../../hooks/useMediaQuery";

export default function RegisterModal() {

  const [loading, setLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [type, setType] = useState(1);

  const { register, signUpAddress } = useApi();
  const scriptedRef = useScriptRef();

  const { open } = useWeb3Modal()
  const { address, isConnected, connector } = useAccount();
  const { connect, isLoading } = useConnect();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width: 720px')

  //phantom
  const { connected, publicKey, disconnect, signMessage: solanaSign } = useWallet();
  const { setVisible } = useWalletModal();

  const metamaskHandler = () => {
    try {
      console.log("address", address);
      signUpAddress(address, 'BCB')
        .then(({ data }) => {
          toast.success(data);
          dispatch(ChangePage('login'))
        })
        .catch((error) => {
          toast.error(error.response.data, { sx: { width: "600px" } })
          setLoading(false);
          setIsLogin(false);
        });
    } catch (e) {
      console.log(e, "error")
    }
  };

  const PhantomHandler = () => {
    let pubAddress = publicKey?.toString();
    signUpAddress(pubAddress, 'SOL')
      .then(({ data }) => {
        dispatch(ChangePage('login'))
        toast.success(data);
      })
      .catch((error) => {
        toast.error(error)
        setLoading(false);
        setIsLogin(false);
      });
  }


  const registerHandler = async (values, { setErrors, setStatus, setSubmitting }) => {
    try {
      await register(values.email, values.username, values.password)
        .then(
          ({ data }) => {
            toast.success(data);
            dispatch(ChangePage("login"))
          },
          (err) => {
            if (scriptedRef.current) {
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
            toast.error(err.response.data)
            console.log(err, "error")
          }
        )
        .catch((error) => {
          console.log(error, "error")
        });
    } catch (err) {
      console.log(err, "err")
      if (scriptedRef.current) {
        setStatus({ success: false });
        setErrors({ submit: err.message });
        setSubmitting(false);
      }
    }
  };


  const handleClick = async (param) => {
    setIsLogin(true);
    setType(param)

    try {
      if (param === 4 && !connected) {
        setVisible(true)
      } else if (!isConnected && !connector) {
        if (param === 2) {
          open();
        } else {
          connect({
            connector: new InjectedConnector({ chains }),
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  // useEffect(() => {
  //   if (
  //     !window.FlowbiteInstances.instanceExists("Modal", "register-modal")
  //   ) {
  //     initModals();
  //   }
  //   return () => {
  //     window.FlowbiteInstances.getInstance(
  //       "Modal",
  //       "register-modal"
  //     ).destroyAndRemoveInstance();
  //   };
  // }, []);

  useEffect(() => {
    if (isLogin && isConnected && connector && type !== 4) {
      metamaskHandler();
    }
  }, [isConnected, isLogin, connector, type])

  useEffect(() => {
    if (publicKey && connected && isLogin && type === 4) {
      PhantomHandler();
    }
  }, [publicKey, connected, isLogin, type])

  return (
    <>
      <div
        id="register-modal"
        tabIndex={-1}
        style={{ backgroundColor: "rgba(22,22,22,0.8)" }}
        aria-hidden="true"
        className="flex justify-center items-center fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-screen"
        data-modal-backdropclasses="bg-yellow-700"
      >
        <div className="relative w-full max-w-md max-h-full">
          {/* Modal content */}
          <div className="relative bg-white rounded-lg shadow dark:bg-black">
            <button
              type="button"
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
              data-modal-hide="register-modal"
              onClick={() => {
                dispatch(ChangePage(""))
              }}
            >
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
            <div className="px-6 py-6 lg:px-8">
              <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 dark:text-gray-400 mb-4">
                <li className="mr-2">
                  <button
                    onClick={() => {
                      dispatch(ChangePage("login"))
                    }}
                    className="inline-block px-4 py-3 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 dark:hover:text-white"
                    aria-current="page"
                  >
                    Login
                  </button>
                </li>
                <li className="mr-2">
                  <button
                    onClick={() => {
                      dispatch(ChangePage("register"))
                    }}
                    className="inline-block px-4 py-3 rounded-lg text-white bg-yellow-400 active"
                  >
                    Register
                  </button>
                </li>
              </ul>
              <Formik
                initialValues={{
                  email: '',
                  username: '',
                  password: '',
                  cpassword: '',
                  submit: null
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string()
                    .email('Must be a valid email')
                    .max(255)
                    .required('Email is required'),
                  username: Yup.string()
                    .min(6)
                    .max(16)
                    .required('Username is required'),
                  password: Yup.string()
                    .min(8)
                    .max(255)
                    .required('Password is required'),
                  cpassword: Yup.string()
                    .test('passwords-match', 'Passwords must match', function (value) {
                      return this.parent.password === value;
                    })
                    .required('Confirm Password is required'),
                })}
                onSubmit={registerHandler}>
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                  <form className="space-y-6" noValidate onSubmit={handleSubmit} >
                    <div>
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Username *
                      </label>
                      <input
                        type="text"
                        name="username"
                        id="username"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-primary dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Username"
                        required=""
                        value={values.username}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.username && errors.username && (
                        <h4 className="text-sm font-medium text-red-400">
                          {errors.username}
                        </h4>
                      )}
                    </div>
                    <div>
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Your email *
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-primary dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        placeholder="name@company.com"
                        required="true"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.email && errors.email && (
                        <h4 className="text-sm font-medium text-red-400">
                          {errors.email}
                        </h4>
                      )}
                    </div>
                    <div>
                      <label
                        htmlFor="password"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Your password *
                      </label>
                      <input
                        type="password"
                        name="password"
                        id="password"
                        placeholder="••••••••"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-primary dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        required=""
                        onBlur={handleBlur}
                        value={values.password}
                        onChange={handleChange}
                      />
                      {touched.password && errors.password && (
                        <h4 className="text-sm font-medium text-red-400">
                          {errors.password}
                        </h4>
                      )}
                    </div>
                    <div>
                      <label
                        htmlFor="password"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        Confirm password *
                      </label>
                      <input
                        type="password"
                        name="cpassword"
                        id="cpassword"
                        placeholder="••••••••"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-primary dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        required=""
                        onBlur={handleBlur}
                        value={values.cpassword}
                        onChange={handleChange}
                      />
                      {touched.cpassword && errors.cpassword && (
                        <h4 className="text-sm font-medium text-red-400">
                          {errors.cpassword}
                        </h4>
                      )}
                    </div>
                    <button
                      disableElevation
                      disabled={isSubmitting}
                      type="submit"
                      className="w-full text-white bg-yellow-400 hover:bg-yellow-600 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-yellow-400 dark:hover:bg-yellow-600 dark:focus:ring-yellow-800"
                    >
                      Start Playing
                    </button>
                  </form>
                )}
              </Formik>
              <center className="mt-2">
                <p className="text-sm text-gray-300">Or Continue With</p>
              </center>
              <div className="flex flex-row space-x-2 mt-2">
                {!isMobile &&
                  <Button onClick={() => handleClick(3)} layout="primary" className="inline-block flex-1">
                    Coinbase
                  </Button>
                }{" "}
                <Button onClick={() => handleClick(2)} layout="primary" className="inline-block flex-1">
                  Wallet Connect
                </Button>{" "}
                {!isMobile &&
                  <Button onClick={() => handleClick(1)} layout="primary" className="inline-block flex-1">
                    Metamask
                  </Button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
